// import {
//   LlButton,
//   LlCascader,
//   LlCheckbox,
//   LlCheckboxGroup,
//   LlDatePicker,
//   LlDateRange,
//   LlInput,
//   LlInputNumber,
//   LlRadio,
//   LlRadioGroup,
//   LlSelect,
//   LlSwitch,
//   LlTextarea,
//   LlTimePicker,
//   LlTimeRange,
//   LlTreeSearch
// } from '@ll-plus/components/index'

export const checkedType = ['radio', 'checkbox', 'switch']

// export const componentTypes = {
//   button: LlButton,
//   cascader: LlCascader,
//   checkbox: LlCheckbox,
//   'checked-group': LlCheckboxGroup,
//   'date-picker': LlDatePicker,
//   'date-ranger': LlDateRange
//   // input: LlInput,
//   // 'input-number': LlInputNumber
//   // radio: LlRadio
//   // 'radio-group': LlRadioGroup,
//   // select: LlSelect,
//   // switch: LlSwitch,
//   // textarea: LlTextarea,
//   // 'time-picker': LlTimePicker,
//   // 'time-range': LlTimeRange
//   // 'tree-search': LlTreeSearch
// }
